/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InformacoesAdicionaisAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  BUTTON_GERAR = 'button-gerar',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DYNAMIC_FIELDS = 'dynamic-fields',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_RELATORIO = 'field-relatorio',
  FORM_0 = 'form-0',
  FORM_DYNAMIC = 'form-dynamic',
  FORM_RELATORIO = 'form-relatorio',
  LAYOUT_INFORMACOES_ADICIONAIS = 'layout-informacoes-adicionais',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_ACTION = 'panel-action',
  PANEL_DYNAMIC = 'panel-dynamic',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { InformacoesAdicionaisAliases };
